export default "__VITE_ASSET__BSVzBYmu__"